import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Container,
  Row,
  Col,
} from "reactstrap";
import PageLayout from "./PageLayout";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useAppDispatch } from "src/state/store/store";
import { userLoginAction } from "src/state/slices/authSlice";
import { setOffcanvasOpen } from "src/state/slices/asideslice";

function JournalLoginPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (data) => {
    try {
      let res = await dispatch(
        userLoginAction({
          email: data.email,
          password: data.password,
          type: "publisher",
        })
      ).unwrap();
      if (res.status == 200) {
        navigate("/");
        dispatch(setOffcanvasOpen(true));
      }
    } catch (e) {}
  };

  return (
    <PageLayout>
      <main>
        <section
          className="section section-shaped section-lg"
          style={{
            backgroundColor: "#f8f9fa",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg="6">
                {/* Card Component */}
                <Card
                  className="shadow border-0"
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "white",
                  }}
                >
                  <CardHeader
                    className="text-white text-center"
                    style={{
                      backgroundColor: "#5e72e4", // Matches the purple buttons
                      borderRadius: "15px 15px 0 0",
                      padding: "1.5rem",
                    }}
                  >
                    <p style={{ fontSize: "1.7rem", margin: "0.5rem 0 0" }}>
                      Sign in to your Publisher account
                    </p>
                  </CardHeader>
                  <CardBody className="px-lg-5 py-lg-5">
                    {/* Login Form */}
                    <Form role="form" onSubmit={handleSubmit(onSubmit)}>
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent", // Remove background
                              borderColor: "transparent", // Ensure no border around the icon
                            }}
                          >
                            <i className="ni ni-email-83 text-primary" />
                          </InputGroupText>
                          <Controller
                            name="email"
                            control={control}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value:
                                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                message: "Invalid email address",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Email Address"
                                type="email"
                              />
                            )}
                          />
                        </InputGroup>
                        {/* Error message for email */}
                        {errors.email && (
                          <div
                            className="error-text"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {String(errors.email?.message)}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent", // Remove background
                              borderColor: "transparent", // Ensure no border around the icon
                            }}
                          >
                            <i className="ni ni-lock-circle-open text-primary" />
                          </InputGroupText>
                          <Controller
                            name="password"
                            control={control}
                            rules={{
                              required: "Password is required",
                              minLength: {
                                value: 6,
                                message:
                                  "Password must be at least 6 characters",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Password"
                                type={showPassword ? "text" : "password"} // Toggle password visibility
                              />
                            )}
                          />
                          <InputGroupText
                            style={{
                              cursor: "pointer",
                              color: "#808080", // Set icon color to black
                              backgroundColor: "transparent", // Remove background
                              borderColor: "transparent", // Ensure no border around the icon
                            }}
                            onClick={handleTogglePassword}
                          >
                            <i
                              className={`fas ${
                                showPassword ? "fa-eye-slash" : "fa-eye"
                              }`}
                            />
                          </InputGroupText>
                        </InputGroup>
                        {/* Error message for password */}
                        {errors.password && (
                          <div
                            className="error-text"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {String(errors.password?.message)}
                          </div>
                        )}
                      </FormGroup>

                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <Link
                          className="text-primary"
                          to={"/forget-password"}
                          // onClick={(e) => e.preventDefault()}
                          style={{
                            fontSize: "0.9rem",
                            textDecoration: "none",
                          }}
                        >
                          Forgot password?
                        </Link>
                      </div>

                      <div className="text-center">
                        <Button
                          className="btn-lg"
                          color="primary"
                          type="submit"
                          style={{
                            backgroundColor: "#5e72e4", // Matches homepage buttons
                            borderColor: "transparent",
                            borderRadius: "50px",
                            padding: "0.8rem 2rem",
                          }}
                        >
                          Sign In
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                  <div
                    className="text-center"
                    style={{
                      padding: "1.5rem",
                      borderTop: "1px solid #e9ecef",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "0.9rem" }}>
                      Don't have an account?{" "}
                      <Link
                        to="/signup"
                        className="text-primary"
                        style={{ textDecoration: "none", fontWeight: "600" }}
                      >
                        Create one now
                      </Link>
                    </p>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <footer
          className="bg-dark text-white text-center py-3"
          style={{ marginTop: "2rem" }}
        >
          {/* Footer content here */}
        </footer>
      </main>
    </PageLayout>
  );
}

export default JournalLoginPage;
